export function isValidNumber(input: string | number): boolean {
  const value: string = typeof input === 'number' ? String(input) : input;

  if (value.length === 0) {
    return false;
  }

  let hasDecimalPoint = false;
  let hasDigits = false;

  for (let i = 0; i < value.length; i++) {
    const char = value[i];

    if (i === 0 && char === '-') {
      continue;
    }

    if (char === '.') {
      if (hasDecimalPoint) return false;
      hasDecimalPoint = true;
    } else if (!'0123456789'.includes(char)) {
      return false;
    } else {
      hasDigits = true;
    }
  }

  return hasDigits;
}
